import { useCallback } from 'react';
import type { Dispatch } from 'react';
import {
  getNotifications,
  getUnreadCount,
  filterNotificationsByRole,
} from '../../services/notificationService';
import type { NotificationAction, UserSession } from './types';

export function useLoadNotifications(dispatch: Dispatch<NotificationAction>, session: UserSession) {
  const { user, userRole } = session;

  // Load notifications dari database dengan debounce untuk avoid multiple concurrent requests
  const loadNotifications = useCallback(async () => {
    if (!user?.id) {
      return;
    }

    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      dispatch({ type: 'SET_ERROR', payload: null });

      // Fetch notifications
      const data = await getNotifications({ limit: 50 });

      const filtered = filterNotificationsByRole(data, userRole || '');
      dispatch({ type: 'SET_NOTIFICATIONS', payload: filtered });

      // Fetch unread count
      const count = await getUnreadCount();
      dispatch({ type: 'SET_UNREAD_COUNT', payload: count });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Gagal memuat notifikasi';
      dispatch({ type: 'SET_ERROR', payload: message });
      if (import.meta.env.DEV && !(message.includes('abort') || message.includes('canceled'))) {
        console.error('[NotificationContext] Error loading notifications:', err);
      }
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  }, [user?.id, userRole]);

  return { loadNotifications };
}
